import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { InputGroup, InputNumber, Modal, Popover, Whisper } from "rsuite";
import { Steps } from "rsuite";
import { Button, Icon } from "../../components";
import { ButtonType } from "../../components/button";
import { getColorList } from "../../redux/cars";
import { CarDetail, Price } from "../../redux/cars/types/carDetail";
import { Color } from "../../redux/cars/types/color";
import { getCarPriceList, getExtraService } from "../../redux/definitions";
import { ExtraService } from "../../redux/definitions/types/extraService";
import { getLocalized } from "../../redux/localization";
import CustomSelectPicker from "./input";
import "./step.scss";
import * as Yup from "yup";
import garageCart from "../../redux/garageCart";
import { GarageCartItem } from "../../redux/garageCart/type";
import { generateUUID } from "../../helpers/guid";
import { useHistory } from "react-router-dom";
import CustomLoader from "../../components/loader";

const selectPickerWidth = { width: 160 };
const margin = { marginBlockEnd: 6 };

const CreateOfferPage = ({
  garageItem,
  car,
  show,
  onHide,
}: {
  garageItem?: GarageCartItem;
  car: CarDetail;
  show: boolean;
  onHide: () => void;
}) => {
  const localize = useSelector(getLocalized);
  const [stepnumber, setStep] = useState<number>(0);
  const [colors, setColors] = useState<Color[]>([]);
  const history = useHistory();
  console.log(garageItem);
  const [loader, setLoader] = useState(false);
  const [prices, setPrices] = useState<Price[]>([]);
  const [kmLimits, setKmLimits] = useState<Price[]>([]);
  const [extraService, setExtraService] = useState<ExtraService[]>([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getExtraService({
        payload: {
          onSuccess: (message, payload) => setExtraService(payload),
          onError: (message) => {},
        },
        url: "api/definitions/extraservice",
      })
    );
    dispatch(
      getColorList({
        payload: {
          onSuccess: (message, payload) => setColors(payload),
          onError: (message) => {},
        },
        url: "api/car/definitions/color",
      })
    );
    dispatch(
      getCarPriceList({
        payload: {
          onSuccess: (message, payload) => {
            setPrices(payload);
            setKmLimits(payload);
          },
          onError: (message) => {},
        },
        url: "/api/car/price/bycarid/" + car.Id,
      })
    );
  }, [dispatch, car.Id, show]);
  return (
    <Modal
      size={"md"}
      open={show}
      onClose={() => {
        onHide();
        setStep(0);
      }}
      className="offerModal"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="offerTitle header-fontColored mx-3 my-2">
            Teklif Oluştur
          </div>
          <span className="offerResTitle ">
            <div className="detailTitle">
              {car.CarBrand} {car.CarModel}
            </div>
            <div className="detailSubTitle">
              {car.CarVersion} {car.CarPack}
            </div>
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="mt-2 w-100 p-4 mb-4 main-offer-steps">
          {loader && <CustomLoader />}
          <Steps current={stepnumber} style={{}}>
            <Steps.Item description={localize.getString("options")} />
            <Steps.Item description={localize.getString("extraservices")} />
            <Steps.Item description={localize.getString("ordersummary")} />
          </Steps>
        </div>
        <div className="mt-2 py-1 px-4">
          <Formik
            initialValues={
              garageItem
                ? {
                    Id: garageItem.Id,
                    Color: garageItem.Color ?? { Id: "", Name: "" },
                    ColorName: garageItem.Color?.Name ?? "",
                    PeriodId: garageItem.Price?.PeriodId ?? "",
                    YıllıkKmId: garageItem.Price?.KMLimitId ?? "",
                    PriceId: garageItem.Price?.Id ?? "",
                    Price: garageItem.Price ?? {
                      CarId: "",
                      PeriodId: "",
                      PeriodCount: 0,
                      KMLimitId: "",
                      KMLimitPerYear: 0,
                      PricePerMonth: 0,
                    },
                    Count: garageItem.Count ?? 1,
                  }
                : {
                    Id: generateUUID(),
                    ColorName: "",
                    Color: { Id: "", Name: "" },
                    PeriodId: "",
                    YıllıkKmId: "",
                    PriceId: "",
                    Price: {
                      CarId: "",
                      PeriodId: "",
                      PeriodCount: 0,
                      KMLimitId: "",
                      KMLimitPerYear: 0,
                      PricePerMonth: 0,
                    },
                    Count: 1,
                  }
            }
            validationSchema={Yup.object({
              PeriodId: Yup.string().required("zorunlu"),
              PriceId: Yup.string().required("zorunlu"),
            })}
            onSubmit={async (values) => {
              if (stepnumber === 2) {
                setLoader(true);
                if (garageItem) {
                  await dispatch(
                    garageCart.actions.updateGarageItem({
                      Id: values.Id,
                      Price: values.Price,
                      Car: car,
                      Color: values.Color,
                      Count: values.Count,
                      ExtraServices: extraService,
                      Insurance: true,
                    })
                  );
                  setLoader(false);
                  onHide();
                } else {
                  await dispatch(
                    garageCart.actions.addToGarage({
                      Id: values.Id,
                      Price: values.Price,
                      Car: car,
                      Count: values.Count,
                      Color: values.Color,
                      ExtraServices: extraService,
                      Insurance: true,
                    })
                  );

                  setLoader(false);
                  history.push("/garage");
                }
              } else {
                setStep(stepnumber + 1);
              }
            }}
          >
            {({ handleSubmit, values, errors, touched, setFieldValue }) => {
              return (
                <div className="w-100 d-flex flex-column align-items-center ">
                  {stepnumber === 0 && (
                    <div className="w-100 ">
                      <div className="w-100 offerstep1-title">
                        <div className="detailTitle">
                          {car.CarBrand} {car.CarModel}
                        </div>
                        <div className="detailSubTitle">
                          {car.CarVersion} {car.CarPack}
                        </div>
                      </div>
                      <Row className="mt-4 offerstep1">
                        <Col sm={3}>
                          <CustomSelectPicker
                            title={localize.getString("color")}
                            data={colors}
                            cleanable={false}
                            searchable={false}
                            placement="bottomStart"
                            value={values.ColorName}
                            style={selectPickerWidth}
                            placeholder={localize.getString("Select")}
                            labelKey="Name"
                            valueKey="Name"
                            onSelect={(value: string, item: any, event) => {
                              setFieldValue("ColorName", value);
                              setFieldValue("Color", item);
                            }}
                          />
                        </Col>{" "}
                        <Col sm={3}>
                          <CustomSelectPicker
                            title={localize.getString("period")}
                            errors={errors.PriceId}
                            data={
                              prices
                                ? prices
                                    .filter(
                                      (current, i, a) =>
                                        a.findIndex(
                                          (price) =>
                                            price.PeriodId === current.PeriodId
                                        ) === i
                                    )
                                    .sort(
                                      (a, b) => a.PeriodCount - b.PeriodCount
                                    )
                                : []
                            }
                            searchable={false}
                            placement="bottomStart"
                            cleanable={false}
                            value={values.PeriodId}
                            style={selectPickerWidth}
                            placeholder={localize.getString("Select")}
                            labelKey="PeriodCount"
                            valueKey="PeriodId"
                            onSelect={(value: string, event) => {
                              setFieldValue("PeriodId", value);
                              const kmArray = prices?.filter(
                                (x) => x.PeriodId === value
                              );
                              setKmLimits(kmArray ?? []);
                            }}
                          />
                        </Col>{" "}
                        <Col sm={3}>
                          <CustomSelectPicker
                            cleanable={false}
                            title={"Yıllık Kilometre Limiti/KM"}
                            errors={errors.PriceId}
                            data={kmLimits.sort(
                              (a, b) => a.KMLimitPerYear - b.KMLimitPerYear
                            )}
                            searchable={false}
                            value={values.PriceId}
                            placement="bottomStart"
                            style={selectPickerWidth}
                            placeholder={localize.getString("Select")}
                            labelKey="KMLimitPerYear"
                            valueKey="Id"
                            onSelect={(value: string, item: any, event) => {
                              setFieldValue("PriceId", value);
                              setFieldValue("Price", item);
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <div className="responsive-input">
                            <span className="selectPickerLabel" style={margin}>
                              {errors.Count && (
                                <span style={{ color: "red", fontSize: 12 }}>
                                  *
                                </span>
                              )}
                              {localize.getString("carCount")}:{" "}
                            </span>
                            <div className="d-flex">
                              <InputGroup.Button
                                className="inputButton"
                                onClick={() => {
                                  values.Count - 1 > 0 &&
                                    setFieldValue("Count", values.Count - 1);
                                }}
                              >
                                -
                              </InputGroup.Button>
                              <InputNumber
                                className={"custom-input-number"}
                                defaultValue={values.Count}
                                value={values.Count}
                                scrollable={false}
                                onChange={(e) => {
                                  setFieldValue("Count", e);
                                }}
                              />
                              <InputGroup.Button
                                className="inputButton"
                                onClick={() => {
                                  setFieldValue("Count", values.Count + 1);
                                }}
                              >
                                +
                              </InputGroup.Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}
                  {stepnumber === 1 && (
                    <div className="d-flex justify-content-start flex-wrap w-100 gap-4">
                      {extraService?.map((service, i) => {
                        return (
                          <div
                            className="offer-extraservice xs-bold-text"
                            style={{ color: "#4d4d4d" }}
                          >
                            <span
                              style={{ textAlign: "center" }}
                              className="offer-extra-text"
                            >
                              {service.Name}
                            </span>

                            <Whisper
                              trigger="click"
                              placement={"topStart"}
                              speaker={
                                <Popover>
                                  <span
                                    style={{ textAlign: "center" }}
                                    className="offer-extra-text"
                                  >
                                    {service.Description}
                                  </span>
                                </Popover>
                              }
                            >
                              <button
                                style={{ backgroundColor: "transparent" }}
                              >
                                <Icon
                                  icon="info"
                                  size={14}
                                  style={{
                                    marginBlockEnd: 2,
                                    marginInlineStart: 3,
                                  }}
                                />
                              </button>
                            </Whisper>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {stepnumber === 2 && (
                    <div className="w-100 d-flex flex-column align-items-center ">
                      <div className="w-100 step3">
                        <table className="step3-table">
                          <tr>
                            <th>{localize.getString("km/year")}</th>
                            <th>{localize.getString("rentaltime")}</th>
                            <th>{"Kira Tutarı/Ay"}</th>
                            <th>{localize.getString("carCount")}</th>
                          </tr>
                          <tr>
                            <td>
                              {new Intl.NumberFormat("tr-TR", {
                                maximumSignificantDigits: 5,
                              }).format(values.Price?.KMLimitPerYear)}
                            </td>
                            <td>{values.Price?.PeriodCount}</td>
                            <td>
                              {new Intl.NumberFormat("tr-TR", {
                                maximumSignificantDigits: 5,
                              }).format(values.Price.PricePerMonth)}{" "}
                              TL
                            </td>
                            <td>{values.Count}</td>
                          </tr>
                        </table>
                        <table className="step3-responsive-table">
                          <tr>
                            <th>{localize.getString("km/year")}</th>
                            <td>
                              {new Intl.NumberFormat("tr-TR", {
                                maximumSignificantDigits: 5,
                              }).format(values.Price?.KMLimitPerYear)}
                            </td>
                          </tr>
                          <tr>
                            <th>{localize.getString("price")}</th>
                            <td>
                              {new Intl.NumberFormat("tr-TR", {
                                maximumSignificantDigits: 5,
                              }).format(values.Price.PricePerMonth)}{" "}
                              TL
                            </td>
                          </tr>
                          <tr>
                            <th>{localize.getString("rentaltime")}</th>
                            <td>{values.Price?.PeriodCount}</td>
                          </tr>
                          <tr>
                            <th>{localize.getString("carCount")}</th>
                            <td>{values.Count}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  )}
                  <div className="offerFooterRes d-flex justify-content-end w-100">
                    <div className="offerFooterRes detailSubTitle mx-2">
                      {localize.getString("monthlyprice")}&nbsp;&nbsp;
                      <span className="detailTitle">
                        {new Intl.NumberFormat("tr-TR", {
                          maximumSignificantDigits: 5,
                        }).format(values.Price.PricePerMonth)}{" "}
                        TL
                      </span>
                      + KDV
                    </div>
                  </div>
                  <div
                    className={
                      stepnumber > 0
                        ? "offerFooterDiv d-flex w-100 justify-content-between mt-5"
                        : "offerFooterDiv d-flex w-100 justify-content-end mt-5"
                    }
                  >
                    {stepnumber > 0 && (
                      <Button
                        buttonType={ButtonType.newColored}
                        title={"GERİ"}
                        icon={<Icon icon="left" size={14} />}
                        iconPosition="left"
                        onClick={() => {
                          setStep(stepnumber - 1);
                        }}
                      />
                    )}

                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className=" offerFooter detailSubTitle mx-2">
                        {localize.getString("monthlyprice")}&nbsp;&nbsp;
                        <span className="detailTitle">
                          {new Intl.NumberFormat("tr-TR", {
                            maximumSignificantDigits: 5,
                          }).format(values.Price.PricePerMonth)}
                        </span>{" "}
                        TL + KDV
                      </div>
                      <Button
                        type="submit"
                        customClassName={
                          stepnumber === 2
                            ? garageItem
                              ? ""
                              : " btnGarajEkle"
                            : ""
                        }
                        buttonType={ButtonType.newColored}
                        title={
                          stepnumber === 2
                            ? garageItem
                              ? "DÜZENLE"
                              : "GARAJA EKLE"
                            : "İLERİ"
                        }
                        icon={<Icon icon="right" size={14} />}
                        iconPosition="right"
                        onClick={() => handleSubmit()}
                      />
                    </div>
                  </div>
                </div>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default CreateOfferPage;
